import { IController } from 'angular';
import * as _ from 'lodash';

import { NextRegentsAdminDate } from '../../../../../../../../ng2/shared/constants/next-regents-admin-date.constant';
import { CsvExporterService } from '../../../../../../../../ng2/shared/services/csv-exporter/csv-exporter.service';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

export class RegentsExportTransferCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils', 'CsvExporter'];

  public flattenedStudents;
  public studentsNotScheduledInStars;
  public studentsWithExamsToBeDropped;
  public nextRegentsAdminDate = NextRegentsAdminDate;
  public studentIdsNotScheduledInStars;
  public studentIdsWithExamsToBeDropped;
  public countExamAdds;
  public countExamDrops;
  public options: IWizardFilterActionsOptions;

  constructor(public $scope, private WizardUtils: WizardUtils, private CsvExporter: CsvExporterService) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.flattenedStudents = this.WizardUtils.getFilteredFlattenedStudents();
    const buckets = this.getBuckets();
    this.studentsNotScheduledInStars = buckets.studentsWithAdds;
    this.studentsWithExamsToBeDropped = buckets.studentsWithDrops;
    this.countExamAdds = buckets.countOfExamsToBeAdded;
    this.countExamDrops = buckets.countOfExamsToBeDropped;
    this.studentIdsNotScheduledInStars = _.map(this.studentsNotScheduledInStars, ({ studentId }) => studentId);
    this.studentIdsWithExamsToBeDropped = _.map(this.studentsWithExamsToBeDropped, ({ studentId }) => studentId);
    this.options = {
      columnKeys: [
        'regentsSchedForNextAdmin',
        'regentsSchedInStarsNextAdmin',
        'examsSchedInPortalNotPlannedInStars',
        'examsToBeDroppedFromStars',
      ],
    };
  }

  exportStarsDataAsCsv(): void {
    const type = 'text/csv;charset=utf-8';
    const csvString: any = this.CsvExporter.createStarsRegentsScheduleExport(this.flattenedStudents);
    this.CsvExporter.exportCsv(csvString, `STARS Regents Upload ${this.nextRegentsAdminDate}.csv`, type);
  }

  private getBuckets() {
    const buckets = {
      studentsWithAdds: [],
      countOfExamsToBeAdded: 0,
      studentsWithDrops: [],
      countOfExamsToBeDropped: 0,
    };
    return _.reduce(
      this.flattenedStudents,
      (result, student: any) => {
        if (student.status === 'A') {
          const { examsSchedInPortalNotPlannedInStars, examsToBeDroppedFromStars } = student;
          const examsToBeAdded = examsSchedInPortalNotPlannedInStars.length;
          if (examsToBeAdded > 0) {
            result.studentsWithAdds.push(student);
            result.countOfExamsToBeAdded += examsToBeAdded;
          }
          const examsToBeDropped = examsToBeDroppedFromStars.length;
          if (examsToBeDropped > 0) {
            result.studentsWithDrops.push(student);
            result.countOfExamsToBeDropped += examsToBeDropped;
          }
        }
        return result;
      },
      buckets,
    );
  }
}
